<template>
    <div class="home">
        <!--        banner-->
        <div class="banner-swiper wow fadeInUp">
            <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(item,index) in banner" :key="index">
                    <img :src="item.coverImage" alt="">
                </div>
            </div>
            <!-- Add Pagination -->
            <div class="swiper-pagination"></div>
        </div>
        <!--        新闻资讯-->
        <section class="sec-news index-section" v-if="sec1Data && sec1Data.length > 0">
            <div class="section-title wow fadeInUp">
                <div class="icon">
                    <img src="@/assets/images/tit-news.png" alt="">
                </div>
                <div class="text">
                    <h3>{{ homeComboxData[0] ? homeComboxData[0].nameOne : '' }}</h3>
                    <p>{{ homeComboxData[0] ? homeComboxData[0].nameTwo : '' }}</p>
                </div>
            </div>
            <div class="wp">
                <div class="news-mod">
                    <div class="left wow fadeInLeft">
                        <div class="pic">
                            <img :src="sec1Data[sec1Index].coverImage" alt="">
                        </div>
                        <div class="bot">
                            <template v-if="sec1Data[sec1Index].jumpType == 1">
                                <a :href="'#/detail?type=news&id='+sec1Data[sec1Index].id+'&from=home'" class="text">

                                    <h3>{{ sec1Data[sec1Index].newsTitle }}</h3>
                                    <div class="date">
                                        {{ sec1Data[sec1Index].day }}{{ sec1Data[sec1Index].date }}
                                    </div>
                                </a>

                            </template>
                            <template v-else>
                                <a :href="sec1Data[sec1Index].hyperlink" target="_blank" class="text">
                                    <h3>{{ sec1Data[sec1Index].newsTitle }}</h3>
                                    <div class="date">
                                        {{ sec1Data[sec1Index].day }}{{ sec1Data[sec1Index].date }}
                                    </div>
                                </a>

                            </template>
                        </div>
                    </div>
                    <div class="right">
                        <div class="more">
                            <a href="#/news">
                                <span>了解更多 >></span>
                            </a>
                        </div>
                        <div class="news-list wow fadeInRight">

                            <div class="item" v-for="(item,index) in sec1Data" :key="index"
                                 @mouseover="sec1Index = index"
                            >
                                <div class="date">
                                    <em>{{ item.day }}</em>{{ item.date }}
                                </div>
                                <template v-if="item.jumpType == 1">
                                    <h3><a :href="'#/detail?type=news&id='+item.id+'&from=home'">{{
                                            item.newsTitle
                                        }}</a>
                                    </h3>
                                </template>
                                <template v-else>
                                    <h3><a :href="item.hyperlink" target="_blank">{{ item.newsTitle }}</a></h3>
                                </template>

                                <p>{{ item.briefIntroduction }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!--        视频专区-->
        <section class="sec-video index-section">
            <div class="section-title wow fadeInUp">
                <div class="icon">
                    <img src="@/assets/images/tit-video.png" alt="">
                </div>
                <div class="text">
                    <h3>{{ homeComboxData[1] ? homeComboxData[1].nameOne : '' }}</h3>
                    <p>{{ homeComboxData[1] ? homeComboxData[1].nameTwo : '' }}</p>
                </div>
            </div>
            <div class="wp wow fadeInUp">
                <div class="video-swiper-wrap">
                    <div class="video-swiper">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide" v-for="(item,index) in videoList" :key="index">
                                <div class="pic" @click="openVideo(item.video)">
                                    <img :src="item.coverImage" alt="">
                                    <i></i>
                                </div>
                                <h3>{{ item.title }}</h3>
                            </div>
                        </div>
                    </div>
                    <div class="swiper-button-next"></div>
                    <div class="swiper-button-prev"></div>
                    <!--                    <a href=" http://www.newwest.cn:9592/login?redirect=/index" target="_blank" class="link-btn">-->
                    <!--                        更多项目信息请登录“蒙科聚”北京分平台-->
                    <!--                    </a>-->
                </div>

            </div>
        </section>
        <div class="m-pop" id="video-pop" v-if="showVideo">
            <div class="pop-mask" @click="showVideo = false;video = ''"></div>
            <div class="pop-con">
                <video :src="video" controls></video>
            </div>
        </div>
        <!--        核心业务-->
        <section class="sec-business index-section">
            <div class="section-title wow fadeInUp">
                <div class="icon">
                    <img src="@/assets/images/tit-business.png" alt="">
                </div>
                <div class="text">
                    <h3>{{ homeComboxData[2] ? homeComboxData[2].nameOne : '' }}</h3>
                    <p>{{ homeComboxData[2] ? homeComboxData[2].nameTwo : '' }}</p>
                </div>
            </div>
            <div class="wp">
                <div class="business-list">
                    <a :href="item.link" class="item wow fadeInUp" v-for="(item,index) in businessList" :key="index">
                        <div class="pic">
                            <div class="icon">
                                <img src="@/assets/images/bi1.png" alt="">
                            </div>
                            <div class="txt">
                                <div class="tit">{{ item.title }}</div>
                                <div class="en">{{ item.titleTwo }}</div>
                            </div>
                            <img :src="item.coverImage" alt="" class="bg">
                        </div>
                        <div class="text">
                            {{ item.briefIntroduction }}
                        </div>
                    </a>
                </div>

            </div>
        </section>
        <!--        优秀项目推介-->
        <section class="sec-promotion index-section">
            <div class="section-title wow fadeInUp">
                <div class="icon">
                    <img src="@/assets/images/tit-promotion.png" alt="">
                </div>
                <div class="text">
                    <h3>{{ homeComboxData[3] ? homeComboxData[3].nameOne : '' }}</h3>
                    <p>{{ homeComboxData[3] ? homeComboxData[3].nameTwo : '' }}</p>
                </div>
            </div>
            <div class="promotion-mod">
                <div class="top-tab wow fadeInUp">
                    <div class="wp">
                        <div class="item"
                             v-for="(item,index) in promotionData" :key="index"
                             @click="promotionIndex = index" :class="{active:promotionIndex === index}">
                            <div class="icon">
                                <div class="icon-inner">
                                    <img :src="item.iconBlack" alt="" class="def">
                                    <img :src="item.icon" alt="" class="on">
                                </div>
                            </div>
                            <div class="name">{{ item.title }}</div>
                        </div>

                        <div class="arrow-l" @click="promotionToLeft"></div>
                        <div class="arrow-r" @click="promotionToRight"></div>
                    </div>
                </div>
                <div class="wp wow fadeInUp">
                    <div class="bot-con">
                        <div class="pic">
                            <img :src="promotionData[promotionIndex].coverImage" alt="">
                        </div>
                        <div class="con">
                            <a href="https://www.newwest.cn:9592/login?redirect=/index" target="_blank">了解更多</a>
                            <div class="con-text ql-editor" v-html="promotionData[promotionIndex].content"></div>
                            <!--                            <h3>{{ promotionData[promotionIndex].title }}</h3>-->
                            <!--                            <p>{{ promotionData[promotionIndex].desc1 }}</p>-->
                            <!--                            <p>{{ promotionData[promotionIndex].desc2 }}</p>-->
                            <div class="page">
                                <div class="arrow-l" @click="promotionToLeft"></div>
                                <em>{{ promotionIndex + 1 }}</em>
                                <span>/6</span>
                                <div class="arrow-r" @click="promotionToRight"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!--        重点需求推介-->
        <section class="sec-demand index-section">
            <div class="section-title wow fadeInUp">
                <div class="icon">
                    <img src="@/assets/images/tit-demand.png" alt="">
                </div>
                <div class="text">
                    <h3>{{ homeComboxData[4] ? homeComboxData[4].nameOne : '' }}</h3>
                    <p>{{ homeComboxData[4] ? homeComboxData[4].nameTwo : '' }}</p>
                </div>
            </div>
            <div class="demand-swiper wow fadeInUp">
                <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="(item,index) in demandData" :key="index">
                        <div class="pic">
                            <img :src="item.coverImage" alt="">
                        </div>
                        <div class="text">
                            <div class="icon">
                                <img :src="item.icon" alt="">
                            </div>
                            <div class="title">
                                <div class="zh">{{ item.title }}</div>
                                <div class="en">{{ item.titleTwo }}</div>
                            </div>
                            <div class="desc">
                                {{ item.briefIntroduction }}
                            </div>
                            <a href="https://www.newwest.cn:9592/login?redirect=/index" target="_blank"
                               class="more"><span>了解更多</span><i></i></a>
                        </div>
                    </div>
                </div>

                <div class="swiper-button-next"></div>
                <div class="swiper-button-prev"></div>
            </div>
        </section>
        <!--        落地内蒙古项目-->
        <section class="sec-project index-section">
            <div class="section-title wow fadeInUp">
                <div class="icon">
                    <img src="@/assets/images/tit-project.png" alt="">
                </div>
                <div class="text">
                    <h3>{{ homeComboxData[5] ? homeComboxData[5].nameOne : '' }}</h3>
                    <p>{{ homeComboxData[5] ? homeComboxData[5].nameTwo : '' }}</p>
                </div>
            </div>
            <div class="wp">
                <div class="project-mod">
                    <div class="big wow fadeInUp" @click="toProjectDet(projectData[projectIndex])">
                        <a :href="'#/detail?type=project&from=project&id='+projectData[projectIndex].id" class="more">了解更多</a>
                        <img :src="projectData[projectIndex].coverImage" alt="">
                        <div class="text">
                            <h3>{{ projectData[projectIndex].title }}</h3>
                            <p>{{ projectData[projectIndex].briefIntroduction }}</p>
                        </div>
                    </div>
                    <div class="project-swiper-wrap wow fadeInUp">
                        <div class="project-swiper">
                            <div class="swiper-wrapper">
                                <div class="swiper-slide"
                                     @mouseover="projectIndex = index"
                                     @click="toProjectDet(item)"
                                     v-for="(item,index) in projectData" :key="index">
                                    <a :href="'#/detail?type=project&from=project&id='+item.id" class="pic">
                                        <img :src="item.coverImage" alt="">
                                    </a>
                                    <div class="text">
                                        <h3><a  :href="'#/detail?type=project&from=project&id='+item.id" >{{ item.title }}</a></h3>
                                        <p>{{ item.briefIntroduction }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="swiper-button-next"></div>
                        <div class="swiper-button-prev"></div>
                    </div>
                    <a href="https://www.techreform.net/pc_index" target="_blank" class="link-btn">
                        更多项目信息请登录‘科技兴蒙创新服务平台’
                    </a>
                </div>
            </div>
        </section>
        <!--        在孵明星企业-->
        <section class="sec-star index-section">
            <div class="section-title wow fadeInUp">
                <div class="icon">
                    <img src="@/assets/images/tit-star.png" alt="">
                </div>
                <div class="text">
                    <h3>{{ homeComboxData[6] ? homeComboxData[6].nameOne : '' }}</h3>
                    <p>{{ homeComboxData[6] ? homeComboxData[6].nameTwo : '' }}</p>
                </div>
            </div>
            <div class="wp wow fadeInUp">
                <div class="star-mod">
                    <div class="top-tab">
                        <div class="item"
                             v-for="(item,index) in starTab" :key="index"
                             @click="changeStar(item,index)" :class="{active:starIndex === index}">{{ item.type }}
                        </div>
                    </div>
                    <div class="list">
                        <div class="item" v-for="(item,index) in starData" :key="index">
                            <template v-if="item.hyperlink">
                                <a :href="item.hyperlink" target="_blank">
                                    <div class="pic">
                                        <img :src="item.coverImage" alt="">
                                    </div>
                                    <div class="name">{{ item.title }}</div>
                                </a>
                            </template>
                            <template v-else>
                                <a   target="_blank">
                                    <div class="pic">
                                        <img :src="item.coverImage" alt="">
                                    </div>
                                    <div class="name">{{ item.title }}</div>
                                </a>
                            </template>

                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!--        发布信息-->
        <PublicPop v-if="showPop" @closePop="showPop = false"/>
        <div class="public-btn" @click="showPop = true">
            <i></i>
            <span>发布信息</span>
        </div>
    </div>
</template>

<script>
import {WOW} from "wowjs";
import "swiper/dist/css/swiper.min.css";
import Swiper from "swiper";
import {
    aboutListApi,
    bannerListApi,
    bannerTypeListApi,
    cooperateComBoxApi, headerFooterApi, homeComBoxApi, homeIncubateListApi, homeListApi, homeNewsListApi,
    incubateComBoxApi, incubateCoopComBoxApi, incubateListApi, newsListApi, newsTypeListApi,
    talentComBoxApi,
    talentListApi
} from "@/api";
import PublicPop from "@/components/PublicPop.vue";

export default {
    data: function () {
        return {
            showPop: false,
            showVideo: false,
            sec1Index: 0,
            sec1Data: [
                {
                    title: '内蒙古科创中心（北京）启动 现场签订协议12项',
                    desc: ' 10月26日，内蒙古科创中心（北京）在北京中关村京蒙高科企业孵化器有限责任公司大厦挂牌成立',
                    date: '/09/2023',
                    day: '05',
                    image: require('@/assets/images/p1.jpg')
                },
                {
                    title: '京蒙高科成立于2002年11月，是自治区较早在北京',
                    desc: ' 10月26日，内蒙古科创中心（北京）在北京中关村京蒙高科企业孵化器有限责任公司大厦挂牌成立',
                    date: '/09/2023',
                    day: '05',
                    image: require('@/assets/images/p1.jpg')
                },
                {
                    title: '京蒙高科作为自治区“一心多点”人才工作新格局',
                    desc: ' 10月26日，内蒙古科创中心（北京）在北京中关村京蒙高科企业孵化器有限责任公司大厦挂牌成立',
                    date: '/09/2023',
                    day: '05',
                    image: require('@/assets/images/p1.jpg')
                }
            ],
            promotionIndex: 0,
            promotionData: [
                {
                    title: '机械项目',
                    desc1: '机械行业形势分析，企业手持订单的增长幅度并不低，预计不会出现使生产大起大落的问题。下半年机械工业经济运行态势仍保持稳步增长。工业总产值、工业增加值、主营业务收入、利润总额、外贸出口额将保持25%左右的较高速度增长。',
                    desc2: ' 从产能挖掘阶段进入产能扩张阶段，机床工业很可能迎来一个加速发展阶段。受下游多个子行业轮流推动，行业因此增长趋势更为稳健。其中，大型、重型机床工业的发展要远快于普通中小型机床工业。'
                },
                {
                    title: '旅游项目',
                    desc1: '机械行业形势分析，企业手持订单的增长幅度并不低，预计不会出现使生产大起大落的问题。下半年机械工业经济运行态势仍保持稳步增长。工业总产值、工业增加值、主营业务收入、利润总额、外贸出口额将保持25%左右的较高速度增长。',
                    desc2: ' 从产能挖掘阶段进入产能扩张阶段，机床工业很可能迎来一个加速发展阶段。受下游多个子行业轮流推动，行业因此增长趋势更为稳健。其中，大型、重型机床工业的发展要远快于普通中小型机床工业。'
                },
                {
                    title: '金融项目',
                    desc1: '机械行业形势分析，企业手持订单的增长幅度并不低，预计不会出现使生产大起大落的问题。下半年机械工业经济运行态势仍保持稳步增长。工业总产值、工业增加值、主营业务收入、利润总额、外贸出口额将保持25%左右的较高速度增长。',
                    desc2: ' 从产能挖掘阶段进入产能扩张阶段，机床工业很可能迎来一个加速发展阶段。受下游多个子行业轮流推动，行业因此增长趋势更为稳健。其中，大型、重型机床工业的发展要远快于普通中小型机床工业。'
                },
                {
                    title: '房地产项目',
                    desc1: '机械行业形势分析，企业手持订单的增长幅度并不低，预计不会出现使生产大起大落的问题。下半年机械工业经济运行态势仍保持稳步增长。工业总产值、工业增加值、主营业务收入、利润总额、外贸出口额将保持25%左右的较高速度增长。',
                    desc2: ' 从产能挖掘阶段进入产能扩张阶段，机床工业很可能迎来一个加速发展阶段。受下游多个子行业轮流推动，行业因此增长趋势更为稳健。其中，大型、重型机床工业的发展要远快于普通中小型机床工业。'
                },
                {
                    title: '农业项目',
                    desc1: '机械行业形势分析，企业手持订单的增长幅度并不低，预计不会出现使生产大起大落的问题。下半年机械工业经济运行态势仍保持稳步增长。工业总产值、工业增加值、主营业务收入、利润总额、外贸出口额将保持25%左右的较高速度增长。',
                    desc2: ' 从产能挖掘阶段进入产能扩张阶段，机床工业很可能迎来一个加速发展阶段。受下游多个子行业轮流推动，行业因此增长趋势更为稳健。其中，大型、重型机床工业的发展要远快于普通中小型机床工业。'
                },
                {
                    title: '制造业项目',
                    desc1: '机械行业形势分析，企业手持订单的增长幅度并不低，预计不会出现使生产大起大落的问题。下半年机械工业经济运行态势仍保持稳步增长。工业总产值、工业增加值、主营业务收入、利润总额、外贸出口额将保持25%左右的较高速度增长。',
                    desc2: ' 从产能挖掘阶段进入产能扩张阶段，机床工业很可能迎来一个加速发展阶段。受下游多个子行业轮流推动，行业因此增长趋势更为稳健。其中，大型、重型机床工业的发展要远快于普通中小型机床工业。'
                },
            ],
            projectIndex: 0,
            projectData: [
                {
                    title: '修路、搭桥',
                    desc: '国道G240项目一标段全长4097米，造价约5亿国道G240项目一标段全长4097米，造价约5亿元。全线桥梁共其浇筑和预、工序...',
                    image: require('@/assets/images/mp1.jpg')
                },
            ],
            starIndex: 0,
            starData: [],
            starTab: [],
            homeComboxData: [],
            videoList: [],
            video: '',
            businessList: [],
            demandData: [],
            banner: [],
        }
    },
    name: 'home',
    components: {PublicPop},
    activated() {
        new WOW({live: false}).init()
        this.initSwiper()
        this.getHomeCombox()
        this.getHomeNews()
        this.getVideoList()
        this.getBusinessList()
        this.getPromotionList()
        this.getDemandList()
        this.getProjectList()
        this.getStarList()
        this.getBanner()
    },
    methods: {
        //首页类型信息
        getHomeCombox: function () {
            homeComBoxApi().then(res => {
                if (res.code === 200) {
                    this.homeComboxData = res.data
                }
            })
        },
        //获取首页新闻
        getHomeNews: function () {
            homeNewsListApi({pageNum: 1, pageSize: 5}).then(res => {
                if (res.code === 200) {
                    this.sec1Data = res.rows;
                    console.log(this.sec1Data)
                    if (this.sec1Data && this.sec1Data.length > 0) {
                        this.sec1Data.map(item => {
                            item.day = item.createTime.split('-')[2].split(' ')[0]
                            item.date = '/' + item.createTime.split('-')[1] + '/' + item.createTime.split('-')[0]
                        })
                    }

                }
            })
        },
        //视频专区
        getVideoList: function () {
            homeListApi({type: 2, pageNum: 1, pageSize: 100}).then(res => {
                if (res.code === 200) {
                    this.videoList = res.rows;

                    setTimeout(function () {
                        var swiper2 = new Swiper('.video-swiper', {
                            slidesPerView: 4,
                            spaceBetween: 20,
                            navigation: {
                                nextEl: ".video-swiper-wrap .swiper-button-next",
                                prevEl: ".video-swiper-wrap .swiper-button-prev",
                            },
                            breakpoints: {
                                767: {  //当屏幕宽度大于等于320
                                    slidesPerView: 2,
                                    spaceBetween: 10
                                },
                                959: {  //当屏幕宽度大于等于768
                                    slidesPerView: 3,
                                    spaceBetween: 20
                                },
                            }
                        });
                    }, 300)

                }
            })
        },
        //播放视频
        openVideo: function (video) {
            this.video = video;
            this.showVideo = true
        },
        //核心业务
        getBusinessList: function () {
            homeListApi({type: 3, pageNum: 1, pageSize: 100}).then(res => {
                if (res.code === 200) {
                    this.businessList = res.rows;

                    this.businessList.map(item => {
                        if (item.typeTwo == 1) {
                            item.link = '#/talent?tab=0'
                        }
                        if (item.typeTwo == 2) {
                            item.link = '#/talent?tab=1'
                        }
                        if (item.typeTwo == 3) {
                            item.link = '#/talent?tab=2'
                        }
                    })
                }
            })
        },
        //优秀项目推荐
        getPromotionList: function () {
            homeListApi({type: 4, pageNum: 1, pageSize: 100}).then(res => {
                if (res.code === 200) {
                    this.promotionData = res.rows;
                }
            })
        },
        //重点需求推荐
        getDemandList: function () {
            homeListApi({type: 5, pageNum: 1, pageSize: 100}).then(res => {
                if (res.code === 200) {
                    this.demandData = res.rows;
                    setTimeout(function () {
                        var swiper3 = new Swiper('.demand-swiper', {
                            slidesPerView: 4,
                            spaceBetween: 0,
                            navigation: {
                                nextEl: ".demand-swiper .swiper-button-next",
                                prevEl: ".demand-swiper .swiper-button-prev",
                            }, breakpoints: {
                                767: {  //当屏幕宽度大于等于320
                                    slidesPerView: 1.5,
                                    centeredSlides: true,
                                    loop: true,
                                },
                                959: {  //当屏幕宽度大于等于768
                                    slidesPerView: 3,
                                },
                                1280: {  //当屏幕宽度大于等于1280
                                    slidesPerView: 4,
                                }
                            }
                        });
                    }, 300)
                }
            })
        },
        //落地内蒙古项目
        getProjectList: function () {
            homeListApi({type: 6, pageNum: 1, pageSize: 100}).then(res => {
                if (res.code === 200) {
                    this.projectData = res.rows;
                    setTimeout(function () {
                        var swiper4 = new Swiper('.project-swiper', {
                            slidesPerView: 4,
                            spaceBetween: 20,
                            navigation: {
                                nextEl: ".project-swiper-wrap .swiper-button-next",
                                prevEl: ".project-swiper-wrap .swiper-button-prev",
                            },
                            breakpoints: {
                                767: {  //当屏幕宽度大于等于320
                                    slidesPerView: 2,
                                },
                                959: {  //当屏幕宽度大于等于768
                                    slidesPerView: 3,
                                },
                                1280: {  //当屏幕宽度大于等于1280
                                    slidesPerView: 4,
                                }
                            }
                        });
                    }, 300)
                }
            })
        },
        //在孵明星企业
        getStarList: function () {
            incubateCoopComBoxApi().then(res => {
                this.starTab = res.data;
                this.getStarLogos(res.data[0].id)
            })
        },
        changeStar: function (item, index) {
            this.starIndex = index;
            this.getStarLogos(item.id)
        },
        getStarLogos: function (type) {
            homeListApi({type: 7, typeTwo: type, pageNum: 1, pageSize: 100}).then(res => {
                if (res.code === 200) {
                    this.starData = res.rows;
                }
            })
        },
        //获取banner
        getBanner: function () {
            bannerTypeListApi().then(res => {
                if (res.code === 200) {

                }
            })
            bannerListApi().then(res => {
                this.banner = []
                if (res.code === 200) {
                    res.data.map(item => {
                        if (item.position == '1') {
                            this.banner.push(item)
                        }
                    })

                    setTimeout(function () {
                        var swiper = new Swiper('.banner-swiper', {
                            pagination: {
                                el: '.banner-swiper .swiper-pagination',
                                clickable: true
                            },
                            autoHeight: true
                        });
                    }, 300)
                }
            })
        },


        initSwiper: function () {


        },
        promotionToLeft: function () {
            if (this.promotionIndex === 0) {
                this.promotionIndex = this.promotionData.length - 1
            } else {
                this.promotionIndex--
            }
        },
        promotionToRight: function () {
            if (this.promotionIndex === this.promotionData.length - 1) {
                this.promotionIndex = 0
            } else {
                this.promotionIndex++
            }
        },

        // 落地项目详情页
        toProjectDet: function (item) {
            localStorage.setItem('projectDetail', JSON.stringify(item))
            // this.$router.push('/detail?id='+item.id+'&type=project&from=project')
        }
    }
}
</script>

<style lang="scss">

</style>
